//
// # 处理API相关的模型数据
//

const state = {
    callResult: {
        code: 0,
        message: "",
        data: null
    }
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
    callResult(state, result) {
        state.callResult = result;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}